import { render } from "./OonaLogo.vue?vue&type=template&id=1d305865&scoped=true"
const script = {}

import "./OonaLogo.vue?vue&type=style&index=0&id=1d305865&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d305865"]])

export default __exports__